"use client";

import React from "react";
import { cn } from "utils";
import type { ThemeChipProps } from "./types";

/**
 * 主题芯片组件 - 用于显示主题标签
 */
export const ThemeChip: React.FC<ThemeChipProps> = ({
  theme,
  onClick,
  className,
}) => {
  return (
    <div
      data-openreplay-label="home_themechip_search"
      className={cn(
        "inline-flex items-center justify-center min-w-13 px-2 py-1.5 rounded-1.5 cursor-pointer transition-colors",
        "body_medium_s text-content_secondary hover:text-content_primary bg-background_white_overlay5",
        className,
      )}
      onClick={onClick}
    >
      <span className="whitespace-nowrap">{theme.name}</span>
    </div>
  );
};
